import { useState, useEffect, useMemo, useCallback } from 'react';
import { loadSlim } from "@tsparticles/slim";
import { initParticlesEngine } from "@tsparticles/react";
import {
    type Container,
    type ISourceOptions,
    MoveDirection,
    OutMode,
} from "@tsparticles/engine";

export const useParticles = () => {
    const [init, setInit] = useState(false);

    const particlesLoaded = useCallback((container?: Container) => {
        // Função vazia ou lógica adicional
    }, []);

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadSlim(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    const options: ISourceOptions = useMemo(
        () => ({
            background: {
                color: {
                    value: "#1c1c1b",
                },
            },
            fpsLimit: 120,
            interactivity: {
                events: {
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                    onHover: {
                        enable: true,
                        mode: "grab",
                    },
                },
                modes: {
                    push: {
                        quantity: 1,
                    },
                    grab: {
                        distance: 200,
                        quantity: 2,
                        links: {
                            opacity: 1,
                        },
                    }
                },
            },
            particles: {
                color: {
                    value: "#FFFCFF",
                },
                links: {
                    color: "#FFFCFF",
                    distance: 200,
                    enable: true,
                    opacity: 0.3,
                    width: 1,
                },
                move: {
                    direction: MoveDirection.none,
                    enable: true,
                    outModes: {
                        default: OutMode.out,
                    },
                    random: true,
                    speed: 2,
                    straight: false,
                },
                number: {
                    density: {
                        enable: true,
                    },
                    value: 160,
                },
                opacity: {
                    value: 0.5,
                },
                shape: {
                    type: "circle",
                },
                size: {
                    value: { min: 1, max: 2 },
                },
            },
            detectRetina: true,
        }),
        [],
    );

    return { 
        options,
        particlesLoaded
    }
}

export default useParticles;